import { forwardRef } from 'react';

import {
  AddCurrencyFilledIcon,
  RubiesFilledIcon,
} from '@wwe-portal/ui/components/icons';

export interface RubiesAmountProps {
  amount: string;
  onClickAdd: () => void;
}

export const RubiesAmount = forwardRef<HTMLDivElement, RubiesAmountProps>(
  ({ amount, onClickAdd }: RubiesAmountProps, ref) => {
    return (
      <div
        className="relative h-[22px] w-[126px] pl-[13px] pr-[11px]"
        data-theme="dark"
        ref={ref}
      >
        <div className="inset-l-[14px] inset-r-[11px] text-text300 absolute inset-y-0 w-[102px] bg-black text-center text-base font-bold">
          {amount}
        </div>
        <div className="absolute inset-y-0 left-0 h-[22px] w-[26px]">
          <RubiesFilledIcon className="text-goldtier absolute inset-x-0 bottom-0 top-[-1.5px] ml-[3px] size-full h-6 w-[23px]" />
        </div>
        <AddCurrencyFilledIcon
          className="absolute inset-y-0 right-0 size-[22px] h-[22px] w-[21px] cursor-pointer rounded-full"
          onClick={onClickAdd}
        />
      </div>
    );
  }
);

RubiesAmount.displayName = 'RubiesAmount';
